// Module Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_MODULES = 'GET_MODULES';
export const GET_MODULES_SUCCESS = 'GET_MODULES_SUCCESS';
export const GET_MODULES_FAIL = 'GET_MODULES_FAIL';
export const GET_MODULES_RESET = 'GET_MODULES_RESET';

export const GET_MODULE_BY_ID = 'GET_MODULE_BY_ID';
export const GET_MODULE_BY_ID_SUCCESS = 'GET_MODULE_BY_ID_SUCCESS';
export const GET_MODULE_BY_ID_FAIL = 'GET_MODULE_BY_ID_FAIL';
export const GET_MODULE_BY_ID_RESET = 'GET_MODULE_BY_ID_RESET';

export const CREATE_MODULE = 'CREATE_MODULE';
export const CREATE_MODULE_SUCCESS = 'CREATE_MODULE_SUCCESS';
export const CREATE_MODULE_FAIL = 'CREATE_MODULE_FAIL';
export const CREATE_MODULE_RESET = 'CREATE_MODULE_RESET';

export const UPDATE_MODULE = 'UPDATE_MODULE';
export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS';
export const UPDATE_MODULE_FAIL = 'UPDATE_MODULE_FAIL';
export const UPDATE_MODULE_RESET = 'UPDATE_MODULE_RESET';

export const DELETE_MODULE = 'DELETE_MODULE';
export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS';
export const DELETE_MODULE_FAIL = 'DELETE_MODULE_FAIL';
export const DELETE_MODULE_RESET = 'DELETE_MODULE_RESET';

export const GET_SUB_MODULES = 'GET_SUB_MODULES';
export const GET_SUB_MODULES_SUCCESS = 'GET_SUB_MODULES_SUCCESS';
export const GET_SUB_MODULES_FAIL = 'GET_SUB_MODULES_FAIL';
export const GET_SUB_MODULES_RESET = 'GET_SUB_MODULES_RESET';

// Thunk Actions
export const getModulesApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_MODULES });
		axios
			.get(`${config.api.base_url}/modules`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getModulesData = response.data;
				dispatch({ type: GET_MODULES_SUCCESS, response: getModulesData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_MODULES_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getModuleByIdApi = (id) => {
	return (dispatch) => {
		dispatch({ type: GET_MODULE_BY_ID });
		axios
			.get(`${config.api.base_url}/modules/${id}`, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getModuleData = response.data;
				dispatch({ type: GET_MODULE_BY_ID_SUCCESS, response: getModuleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_MODULE_BY_ID_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const createModuleApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CREATE_MODULE });
		axios
			.post(`${config.api.base_url}/modules`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createModuleData = response.data;
				dispatch({ type: CREATE_MODULE_SUCCESS, response: createModuleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CREATE_MODULE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const updateModuleApi = (id, data) => {
	return (dispatch) => {
		dispatch({ type: UPDATE_MODULE });
		axios
			.post(`${config.api.base_url}/modules/${id}`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updateModuleData = response.data;
				dispatch({ type: UPDATE_MODULE_SUCCESS, response: updateModuleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: UPDATE_MODULE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const deleteModuleApi = (id) => {
	return (dispatch) => {
		dispatch({ type: DELETE_MODULE });
		axios
			.post(`${config.api.base_url}/modules/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteModuleData = response.data;
				dispatch({ type: DELETE_MODULE_SUCCESS, response: deleteModuleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: DELETE_MODULE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getSubModulesApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_SUB_MODULES });
		axios
			.get(`${config.api.base_url}/modules/sub-modules/all`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getSubModulesData = response.data;
				dispatch({ type: GET_SUB_MODULES_SUCCESS, response: getSubModulesData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_SUB_MODULES_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const createSubModuleApi = (data) => {
	return (dispatch) => {
		dispatch({ type: 'CREATE_SUB_MODULE' });
		return axios
			.post(`${config.api.base_url}/modules/sub-modules`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createSubModuleData = response.data;
				dispatch({ type: 'CREATE_SUB_MODULE_SUCCESS', response: createSubModuleData });
				return createSubModuleData.data || createSubModuleData;
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: 'CREATE_SUB_MODULE_FAIL', response: error.response?.data || errorMsg });
				throw error;
			});
	};
};

export const deleteSubModuleApi = (id) => {
	return (dispatch) => {
		dispatch({ type: 'DELETE_SUB_MODULE' });
		return axios
			.post(`${config.api.base_url}/modules/sub-modules/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteSubModuleData = response.data;
				dispatch({ type: 'DELETE_SUB_MODULE_SUCCESS', response: deleteSubModuleData });
				return id;
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: 'DELETE_SUB_MODULE_FAIL', response: error.response?.data || errorMsg });
				throw error;
			});
	};
};

export const getModulesReset = () => ({ type: GET_MODULES_RESET });
export const getModuleByIdReset = () => ({ type: GET_MODULE_BY_ID_RESET });
export const createModuleReset = () => ({ type: CREATE_MODULE_RESET });
export const updateModuleReset = () => ({ type: UPDATE_MODULE_RESET });
export const deleteModuleReset = () => ({ type: DELETE_MODULE_RESET });
export const getSubModulesReset = () => ({ type: GET_SUB_MODULES_RESET });

